<template>
    <Card>

        <template slot="title">
            Costs Summary
        </template>

        <template>
            <div class="mb-2">
                <div class="d-flex justify-content-between">
                    <div class="font-weight-bold">
                        Event management fee
                    </div>
                    <b-btn
                        size="sm"
                        variant="link"
                        class="p-0"
                        @click="openEditPricingModeModal"
                    >
                        <i class="fa fa-pencil" />
                    </b-btn>
                </div>
                <div>{{ formatCurrency(costsSummary.event_management_fee) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Total cost
                </div>
                <div>{{ formatCurrency(costsSummary.total_cost) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Total price
                </div>
                <div>{{ formatCurrency(costsSummary.total_price) }}</div>
            </div>
            <div
                v-if="costsSummary.price_per_guest != null"
                class="mb-2"
            >
                <div class="font-weight-bold">
                    Price per guest
                </div>
                <div>{{ formatCurrency(costsSummary.price_per_guest) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Markup
                </div>
                <div>{{ formatCurrency(costsSummary.markup) }}</div>
            </div>
            <div class="mb-2 dl-item-margin">
                <div class="font-weight-bold">
                    Margin
                </div>
                <div>{{ formatPercentage(costsSummary.margin) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Margin inc. commission
                </div>
                <div>{{ formatPercentage(costsSummary.margin_including_commission) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Commission
                </div>
                <div>{{ formatCurrency(costsSummary.commission) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Profit
                </div>
                <div>{{ formatCurrency(costsSummary.profit) }}</div>
            </div>
            <div>
                <div class="font-weight-bold">
                    Uplift
                </div>
                <div>{{ formatCurrency(costsSummary.uplift) }}</div>
            </div>
        </template>

    </Card>
</template>

<script>
import Card from '@/components/Card';
import * as helpers from '@/utils/helpers';
import api from '../_api';

export default {

    components: {
        Card,
    },

    computed: {
        costsSummary() {
            return this.$store.getters['costable/costsSummary'];
        },
        costableType() {
            return this.$store.getters['costable/costableType'];
        },
        costableId() {
            return this.$store.getters['costable/costableId'];
        },
    },

    methods: {
        ...helpers,
        openEditPricingModeModal() {
            this.$eventBus.$emit(this.$events.openEditPricingModeModal, {
                title: 'Change Event Pricing Mode',
                onOpen: () => api.getEventPricingMode(this.costableType, this.costableId),
                onSubmit: data => this.$store.dispatch('costable/updateEventPricingMode', data),
            });
        },
    },

};
</script>
